export const classes = {
  wrapper: 'grow flex flex-col pr-2 min-h-0 overflow-auto',
  section: 'mb-4',
  empty:
    'size-full flex justify-center items-start py-2 text-lg text-grey-7 dark:text-mauve-2 font-normal',
};
